module.exports = __webpack_public_path__ + "img/arrow-up.82ef0b31.svg";